import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="analytics--dashboard"
export default class extends Controller {
  static targets = ["error"];
  static values = {
    data: Object,
  };

  connect() {
    this.initializeDashboard();
    // this.trackPerformance();
  }

  disconnect() {}

  // Track performance metrics
  // trackPerformance() {
  //   if ("performance" in window) {
  //     // Track dashboard load time
  //     const loadTime = performance.now();
  //     this.element.setAttribute("data-load-time", loadTime.toFixed(2));

  //     // Track Core Web Vitals if available
  //     if ("web-vital" in window) {
  //       import("web-vitals").then(
  //         ({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
  //           getCLS(console.log);
  //           getFID(console.log);
  //           getFCP(console.log);
  //           getLCP(console.log);
  //           getTTFB(console.log);
  //         },
  //       );
  //     }
  //   }
  // }

  // Initialize dashboard components
  initializeDashboard() {
    this.hideErrors();
    this.updateDashboardContent();
  }

  // Update dashboard content with initial data
  updateDashboardContent() {
    if (!this.hasDataValue) return;

    const data = this.dataValue;

    // Dispatch events to individual section controllers with their data
    this.dispatchSectionUpdate("party_overview", data.party_analytics);
    this.dispatchSectionUpdate("guest_engagement", data.guest_analytics);
    this.dispatchSectionUpdate("financial_insights", data.financial_analytics);
    this.dispatchSectionUpdate("timeline_tasks", data.timeline_analytics);
    this.dispatchSectionUpdate("product_performance", data.product_analytics);
    this.dispatchSectionUpdate("activity", data.recent_activity);
  }

  // Dispatch update events to section controllers
  dispatchSectionUpdate(sectionType, sectionData) {
    const event = new CustomEvent("analytics:sectionDataUpdated", {
      detail: {
        sectionType,
        data: sectionData,
      },
      bubbles: true,
    });
    this.element.dispatchEvent(event);
  }

  // Hide error states
  hideErrors() {
    this.errorTargets.forEach((target) => {
      target.classList.add("hidden");
    });
  }
}
